import {useCallback, useEffect, useRef, useState} from "react";
import {
    COUNTRY_SCOPE_STORAGE_KEY,
    resolveAdminCountryScope,
} from "../../shared/api/countryScope";

const EMPTY_COUNTRIES = [];

export const useContentCountryScope = ({role, allowedCountryIds = EMPTY_COUNTRIES}) => {
    const resolveScope = useCallback((storedScope) => resolveAdminCountryScope({
        role,
        allowedCountryIds,
        storedScope,
    }), [allowedCountryIds, role]);
    const [countryScope, setCountryScope] = useState(() =>
        resolveScope(localStorage.getItem(COUNTRY_SCOPE_STORAGE_KEY)),
    );
    const activeCountryScopeRef = useRef(countryScope);

    useEffect(() => {
        const handleCountryChange = (event) => {
            const nextScope = resolveScope(event.detail?.countryId);
            activeCountryScopeRef.current = nextScope;
            setCountryScope(nextScope);
        };
        window.addEventListener("sorpa-admin-country-scope-change", handleCountryChange);
        return () => window.removeEventListener("sorpa-admin-country-scope-change", handleCountryChange);
    }, [resolveScope]);

    return {countryScope, activeCountryScopeRef};
};
